import type { TypePolicies } from '../../../utils';
import { cursorPaginationFieldPolicy } from '../../../utils/policies';

export const typePolicies: TypePolicies = {
  FolderAsset: {
    fields: {
      assets: {
        ...cursorPaginationFieldPolicy((args) =>
          args?.customSort
            ? ['customSort', 'assetType']
            : ['assetType', 'customSort', 'sortBy']
        ),
      },
    },
  },
};
